import styled from "styled-components";

export const StyledRecoveryFlowAddEmailStep = styled.div`
	max-width: 63rem;
	margin-top: 4rem;

`;
